import classNames from 'classnames';

import { useInlineDialogStyles } from './InlineDialog.styles';

export default function InlineDialog({
  children,
  className,
  title,
  titleId,
  icon,
  visible = true,
  ...rest
}) {
  const { styles } = useInlineDialogStyles();

  return (
    <div className={classNames(styles.inlineDialog, className)} {...rest}>
      {icon && <div className={styles.inlineDialogIcon}>{icon}</div>}
      {children}
    </div>
  );
}
